$(function() {
  jQuery.getJSON('/cart.js', function(cart) {
      let items = cart.items;

      for (var i = 0; i < items.length; i++) {
          if (items[i].title == "Face Scrub - FREE GIFT") {
          	// remove quantity in drawer
          	$(".go-cart-item__info:contains('Face Scrub - FREE GIFT') .go-cart-item__quantity").remove();

          	// remove quantity in /cart view
          	$(".cart__row:contains('Face Scrub - FREE GIFT') .cart__input-quantity").remove();
          }
      }
  });
});
